import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import axios from "../Axios";
import "./Questions.css";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { GuardSpinner } from "react-spinners-kit";

const Questions = () => {
    const [question, setQuestion] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies(null);
    const [isLoading, setLoading] = useState(true);

    const username = cookies.username;

    useEffect(() => {
        getQuestions();
    }, []);

    const getQuestions = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(`/allquestions`);
            setQuestion(data.allQuestions);
            setLoading(false);
        } catch (err) {
            console.log(err.message);
        }
    };

    return (
        <>
            {isLoading ? (
                <div className="loadingIcon">
                    <GuardSpinner frontColor={"#fe8402"} backColor={"#00ff89"} loading={isLoading} size={60} />
                </div>
            ) : (
                <>
                    <Header />
                    <div className="my-5 questions">
                        <div className="container">
                            <div className="d-flex justify-content-between">
                                <Link to="/questions">
                                    <button className="qButton py-2" style={{ backgroundColor: "#516cf0", color: "white" }}>
                                        Ask Question
                                    </button>
                                </Link>
                                <p>Welcome : {username} </p>
                            </div>
                            <h5 className="mt-5">Questions</h5>
                            <div className="py-2">
                                {question.map((el, index) => (
                                    <Link to={"/answers/" + el.question_id}>
                                        <div key={index} style={{ position: "relative", borderBottom: "1px solid #808080", borderTop: index === 0 ? "1px solid #808080" : "" }} className="qIconparent">
                                            <div className="d-inline-flex">
                                                <i className="fa-solid fa-circle-user pe-2 pt-1 text-center" style={{ zoom: "500%" }}></i>
                                                <p className="pt-5">{el.question}</p>
                                            </div>
                                            <div style={{ width: "80px", paddingTop: "10px" }}>
                                                <p style={{ textAlign: "center" }}>{el.user_name}</p>
                                            </div>
                                            <i className="fa-solid fa-chevron-right qicon" style={{ position: "absolute", right: "2.5px", top: "43px", zoom: "150%" }}></i>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </>
    );
};

export default Questions;
